module.exports = __webpack_public_path__ + "img/question.3404fb10.svg";